import { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { TickIcon } from '../../Components/Icons/TickIcon';
import { DeleteIcon } from '../../Components/Icons/DeleteIcon';
import { useTranslation } from "react-i18next";
import { NotificationModel } from '../../Api/Models/user.mode';
import { AttentionIcon } from '../../Components/Icons/AttentionIcon';
import { useEffect } from 'react';

interface NotificationElementProps {
  notification: NotificationModel;
  handleDelete: (id: number) => void;
}

const NotificationElement: React.FunctionComponent<NotificationElementProps> = ({ notification, handleDelete }) => {
  const { t } = useTranslation();
  const [translateX, setTranslateX] = useState(0);
  const maxDeltaX = -90;

  useEffect(() => {
    setTranslateX(0);
  }, [notification.id]);

  const handlers = useSwipeable({
    onSwiping: (eventData) => {
      const { deltaX } = eventData;
      if (deltaX < 0) {
        // Only allow left swipe, restricting it to -90px max
        setTranslateX(Math.max(deltaX, maxDeltaX));
      } else {
        // Allow right swipe to reset position
        setTranslateX(Math.min(deltaX, 0));
      }
    },
    onSwiped: () => {
      if (translateX > -50) {
        setTranslateX(0); // If not swiped enough, reset
      } else {
        // If swiped enough, show delete button
        setTranslateX(maxDeltaX);
      }
    },
    trackMouse: true,
  });



  const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

    if (diffHours < 24) {
      return `${diffHours} h ago`;
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div
      className="relative w-full"
      style={{
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      <div
        {...handlers}
        className="transition-transform"
        style={{
          transform: `translateX(${translateX}px)`,
          position: 'relative',
          zIndex: 2,
        }}
      >

        <div className="notification-list-card">
          <div className="notification-list-card__icon">
            {notification.type === "approved" ? 
              <TickIcon width="20" height="16"/>
            : 
              <AttentionIcon/>
            }
            {/* */}
            {!notification.is_read && (
              <div className="notification-list-card__new-marker"></div>
            )}
          </div>
          <div className="notification-list-card__content">
            {notification.message}
            <div className="notification-list-card__date">{formatDate(notification.created_at)}</div>
          </div>
        </div>

      </div>

      <button
          className="absolute right-0 top-0 bottom-0 left-0"
          onClick={() => handleDelete(notification.id)}
          style={{zIndex: 1}}
      >

        <button
            className="absolute right-0 top-0 bottom-0 left-0"
            onClick={() => handleDelete(notification.id)}
            style={{zIndex: 1}}
        >
          <div className="notification-list-delete">
            <div className="notification-list-delete__content">
              <DeleteIcon/>
              {t('Delete')}
            </div>
          </div>
        </button>

      </button>

    </div>
  );
};

export default NotificationElement;